import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectNewUser = (state: StoreSchema) => state.newUserState.newUser
